import { useMemo } from 'react'
import { StockType } from 'types/stock'
import format from 'date-fns/format'
import { isBefore } from 'date-fns'

const useLastNotifiedTime = (stocks: StockType[]): string => {
  const now = new Date()
  return useMemo(() => {
    // 在庫データがない場合
    if (stocks.length === 0) return '本日通知は行っていません'

    const recentNotifiedStock = stocks
      .filter((stock) => stock.last_notified_time)
      .sort((a, b) => {
        return a.last_notified_time!.toDate() > b.last_notified_time!.toDate() ? -1 : 1
      })
      .find((stock) => isBefore(stock.last_notified_time!.toDate(), now))

    // 前回の通知データがない場合
    if (!recentNotifiedStock || !recentNotifiedStock.last_notified_time) return '本日通知は行っていません'
    return format(recentNotifiedStock.last_notified_time.toDate(), 'HH:mm')
  }, [stocks])
}

export default useLastNotifiedTime
